import { Box, Button, ButtonAppearance, ButtonSize, Heading, Icon, IconSize, ModalBody } from '@bechtel/gds';
import { Formik } from 'formik';
import { FC } from 'react';
import { FormField, MultiLingualText, TextFieldComponent } from '~/components';
import { FooterButtonStyled, ModalCloseStyled, ModalFooterStyled, ModalHeaderStyled, ModalStyled } from './styled';

export interface CopyTagFormikState {
  tag: string;
}

const initialValues: CopyTagFormikState = {
  tag: '',
};

interface CopyModalProps {
  onClose: () => void;
  pickListName: string;
  modalName: string;
  onSubmit: (value: CopyTagFormikState) => any;
  loading: boolean;
}

export const CopyModal: FC<CopyModalProps> = ({ onClose, pickListName, modalName, onSubmit, loading }) => {
  const handleSubmit = async (values: CopyTagFormikState) => {
    if (onSubmit) {
      onSubmit(values);
      return;
    }
  };

  return (
    <>
      <ModalStyled visible>
        <Formik
          initialValues={initialValues}
          onSubmit={(values) => {
            handleSubmit(values);
          }}
        >
          {({ values, handleSubmit }) => {
            return (
              <>
                <ModalHeaderStyled title="">
                  <Box alignItems={{ sm: 'center' }} justifyContent={{ sm: 'space-evenly' }}>
                    <Box pl={{ sm: '300' }}>
                      <Heading size="500" weight="500">
                        <MultiLingualText>{modalName}</MultiLingualText>
                      </Heading>
                    </Box>
                    <ModalCloseStyled
                      onClick={() => {
                        onClose();
                      }}
                    >
                      <Button
                        size={ButtonSize.SMALL}
                        style={{ background: 'transparent', boxShadow: 'none' }}
                        onClick={() => close()}
                      >
                        <Icon icon="times" iconStyle="regular" size={IconSize.LARGE} />
                      </Button>
                    </ModalCloseStyled>
                  </Box>
                </ModalHeaderStyled>
                {/* @ts-ignore adjust in GDS component to take child as prop  */}
                <ModalBody
                  css={`
                    flex-direction: column;
                  `}
                >
                  <form style={{ width: '100%' }}>
                    <Box flexGrow={{ sm: '1' }} p={{ sm: '500' }} pb={{ sm: '500' }}>
                      <FormField
                        memberName="tag"
                        required={true}
                        pickListName={pickListName}
                        tagValidationType="NO_DATA_FOUND"
                      >
                        <TextFieldComponent />
                      </FormField>
                    </Box>
                  </form>
                </ModalBody>
                <ModalFooterStyled>
                  <Box p={{ sm: '500' }} pt={{ sm: '200' }}>
                    <FooterButtonStyled appearance={ButtonAppearance.SECONDARY} onClick={() => onClose()}>
                      <Box px={{ sm: '500' }}>
                        <MultiLingualText>Cancel</MultiLingualText>
                      </Box>
                    </FooterButtonStyled>
                    <FooterButtonStyled onClick={() => handleSubmit()} disabled={!values.tag || loading}>
                      <Box px={{ sm: '500' }}>
                        <MultiLingualText>OK</MultiLingualText>
                      </Box>
                    </FooterButtonStyled>
                  </Box>
                </ModalFooterStyled>
              </>
            );
          }}
        </Formik>
      </ModalStyled>
    </>
  );
};
